import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetEmailCycleDetailsRPC } from "./getEmailCycleDetailsRPC";

export class GetEmailCycleDetailsRPCClientImpl extends GetEmailCycleDetailsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetEmailCycleDetailsRPC.Request): Promise<LeoRPCResult<GetEmailCycleDetailsRPC.Response, GetEmailCycleDetailsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/GetEmailCycleDetails",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetEmailCycleDetailsRPC.ResponseDTO,
      GetEmailCycleDetailsRPC.Errors.ErrorsDTO,
      GetEmailCycleDetailsRPC.Response,
      GetEmailCycleDetailsRPC.Errors.Errors
    >(
      response,
      "email-cycle/GetEmailCycleDetails",
      GetEmailCycleDetailsRPC.Response.fromDTO,
      GetEmailCycleDetailsRPC.Errors.fromDTO
    );
  }
}
